import * as SERVICES from "@/drc/services/drc-request-service";
import store from "@/common/store";
import {NOTIFICATION_TYPE} from "@/common/utils/constants";
import i18n from "@/common/translations/i18n";
import {EventSearch} from "@/common/configurations/event-bus.js";
import * as STATISTIC_SERVICE from "@/common/services/statistic-service";
import loaderService from '@/common/services/loader-service';

export function fetchUserSavedProjectsIds() {
	store.dispatch('showLoading');
	let userId = store.getters.getUser.id;

	SERVICES.fetchUserSavedProjectsIds(userId)
		.then((response) => {
			store.dispatch('addToSavedProjectIds', response.data);
		})
		.catch((error) => {
			console.error(error);
		})
		.finally(() => {
			store.dispatch('hideLoading');
		});
}

export function isInSavedProjects(project) {
	return store.getters.getSavedProjectIds.find(t => t === Number(project.id));
}

export function addToSavedProjects(project) {
	loaderService.show({text: '', description: '', buttonText: null, isBlue: false, onCancel: () => {}});
	let userId = store.getters.getUser.id;
	SERVICES.addProjectToSaved(userId, project.id)
		.then(() => {
			let message = `${i18n.t('notifications.addToSaved')}`;
			showNotification(message, NOTIFICATION_TYPE.SUCCESS);
			fetchUserSavedProjectsIds();
			const props = {
				action: STATISTIC_SERVICE.ACTIONS.COMMON.SAVE,
				project: {id: project.id},
				comment: JSON.stringify({current_route: `${window.location.href}`})
			}
			STATISTIC_SERVICE.addDrcStatistic(props)
		})
		.catch(() => {
			showNotification(`${i18n.t('notifications.failedAddToSaved')}`, NOTIFICATION_TYPE.ERROR);
		})
		.finally(() => loaderService.hide());
}

export function removeFromSavedProjects(project) {
	loaderService.show({text: '', description: '', buttonText: null, isBlue: false, onCancel: () => {}});
	let userId = store.getters.getUser.id;
	SERVICES.removeProjectFromSaved(userId, project.id)
		.then(() => {
			let message = `${i18n.t('notifications.removeFromSaved')}`;
			showNotification(message, NOTIFICATION_TYPE.SUCCESS);
			fetchUserSavedProjectsIds();
			store.dispatch("removeSavedProjectFromStore", project.id);
			store.dispatch("reduceTotalProjectsWithOne");
			EventSearch.$emit("triggerVerificationOfSavedProjectsVisualization", `${store.getters.getSavedProjectIds.length}`);
			const props = {
				action: STATISTIC_SERVICE.ACTIONS.COMMON.UNSAVE,
				project: {id: project.id},
				comment: JSON.stringify({current_route: `${window.location.href}`})
			}
			STATISTIC_SERVICE.addDrcStatistic(props)
		})
		.catch((error) => {
			console.error(error)
			showNotification(`${i18n.t('notifications.failedToRemoveFromSavedProjects')}`, NOTIFICATION_TYPE.ERROR);
		})
		.finally(() => loaderService.hide());
}

function showNotification(message, type) {
	store.dispatch('addNotification', {type: type.toLowerCase(), message: message});
}

export function toggleSavedProjects(project) {
	if (isInSavedProjects(project)) {
		removeFromSavedProjects(project);
	} else {
		addToSavedProjects(project);
	}
}
